import React from 'react';
import Header from '../../components/Header/Header';
import Hero4 from '../../components/Hero4/Hero4';
import Contacts from '../../components/Contacts/Contacts';
import Footer from '../../components/Footer/Footer';

const Page4 = () => {
  return (
    <div>
      <Header />
      <Hero4 />
      <Contacts />
      <Footer />
    </div>
  );
};

export default Page4;
